module.exports = __webpack_public_path__ + "img/v2_7.97473c0d.png";